import * as preact from "preact";
import * as _ from "underscore";

import UserWordModel from "models/UserWordModel";
import * as practiceUtils from "practiceUtils";
import { ChallengeProps } from "practiceUtils";
import MultipleChoiceButtonRow from "views/MultipleChoiceButtonRow";
import PracticeContextView from "views/PracticeContextView";
import PracticePlayTTSView from "views/PracticePlayTTSView";
import TransliterationView from "./TransliterationView";

interface State {
  distractors: string[];
  clozeSentence: practiceUtils.ClozeSentence;
  reportedRecallEase: boolean;
}

class PassiveMultipleChoiceChallengeView extends preact.Component<
  ChallengeProps,
  State
> {
  userWords: Backbone.Collection<UserWordModel>;

  constructor(props: ChallengeProps) {
    super(props);

    this.state = {
      distractors: _.sample(
        props.allUserWords
          .filter(
            (potentialDistractor) =>
              potentialDistractor.id !== props.userWord.id &&
              practiceUtils.normalize(potentialDistractor.get("word")) !==
                practiceUtils.normalize(props.userWord.get("word")) &&
              practiceUtils.normalize(
                potentialDistractor.get("translation")
              ) !== practiceUtils.normalize(props.userWord.get("translation"))
          )
          .map((userWord) =>
            [
              userWord.get("translation"),
              ...userWord.get("alternativeTranslations"),
            ].join(" / ")
          ),
        3
      ),
      clozeSentence: practiceUtils.getClozeSentence(
        props.userWord,
        props.selectedContextIndex
      ),
      reportedRecallEase: false,
    };
  }

  render() {
    const { userWord } = this.props;
    const { clozeSentence } = this.state;

    return (
      <div class="passiveMultipleChoiceChallenge">
        <h2>
          What does{" "}
          <PracticePlayTTSView
            text={userWord.get("word")}
            language={userWord.get("language")}
          />{" "}
          <span class="transliterationContainer">
            <TransliterationView
              language={userWord.get("language")}
              text={userWord.get("word")}
            />
            "{userWord.get("word")}"
          </span>{" "}
          mean here?
        </h2>
        <p>
          <PracticeContextView
            clozeSentence={clozeSentence}
            mode={{ type: "complete" }}
          />
        </p>
        <MultipleChoiceButtonRow
          correctAnswer={[
            userWord.get("translation"),
            ...userWord.get("alternativeTranslations"),
          ].join(" / ")}
          distractors={this.state.distractors}
          onSuccess={() => {
            this.props.completedCallback({
              type: "show-feedback",
              correct: "yes",
            });
            if (!this.state.reportedRecallEase) {
              this.props.reportRecallEase(4);
              this.setState({ reportedRecallEase: true });
            }
          }}
          onFail={() => {
            this.props.completedCallback({
              type: "show-feedback",
              correct: "no",
              message: {
                title: "Incorrect",
                body: `The correct answer is "${userWord.get("translation")}"`,
              },
            });
            if (!this.state.reportedRecallEase) {
              this.props.reportRecallEase(1);
              this.setState({ reportedRecallEase: true });
            }
          }}
          showCorrectAnswer={this.props.skipped}
        />
      </div>
    );
  }
}

export default PassiveMultipleChoiceChallengeView;
